var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"control-panel-v2"},'div',_vm.config.attrs,false),[_c('config-style-injector',{attrs:{"root-selector":`.control-panel`,"config":_vm.config}}),_vm._l((_vm.controls),function(control,i){return _c(control.component,_vm._b({key:control.name + i,tag:"component"},'component',control.attrs,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }